import { GameConstants } from "../GameConstants";
import { Board } from "./Board";
import { GameVars } from "../GameVars";
import { RectangleWithRadius } from "../utils/RectangleWithRadius";
import { ChallengeManager } from "../challenge/ChallengeManager";
import { BoardManagerAI } from "./BoardManagerAI";

export class PawnPromotionLayer extends Phaser.Group {

    constructor(game: Phaser.Game) {

        super(game, null, "pause-layer");

        const darkLayer: Phaser.Sprite = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData(GameConstants.BLACK_SQUARE));
        darkLayer.scale.set(GameConstants.GAME_WIDTH / 64, GameConstants.GAME_HEIGHT / 64);
        darkLayer.alpha = .15;
        darkLayer.inputEnabled = true;
        darkLayer.events.onInputDown.add(this.onDownDarkLayer, this);
        this.add(darkLayer);

        let menuContainer: Phaser.Group = new Phaser.Group(this.game);
        menuContainer.x = GameConstants.GAME_WIDTH / 2;
        menuContainer.y = Board.BOARD_PY;
        menuContainer.scale.y = GameVars.scaleY;
        this.add(menuContainer);

        let w = 440;
        let h = 440;
        let textColor = GameVars.colorPlayer === GameConstants.WHITE ? "#F6F9EF" : "#111E37";
        let menuColor = GameVars.colorPlayer === GameConstants.WHITE ? "#111E37" : "#F6F9EF";

        let menuBackground = new RectangleWithRadius(this.game,
        -w / 2, -h / 2, w, h, 14, menuColor, .9);
        menuContainer.add(menuBackground);

        const promotionTitle = new Phaser.Text(this.game, 0, -182, "Pawn promotion", { font: "46px Roboto Slab Bold", fill: textColor, align: "center"}); 
        promotionTitle.anchor.x = .5;
        menuContainer.add(promotionTitle);

        let choosePieceLabel = new Phaser.Text(this.game, 0, 154, "Choose a piece"
        , { font: "36px Roboto Slab Regular", fill: textColor, align: "center"});
        choosePieceLabel.anchor.set(.5);
        menuContainer.add(choosePieceLabel);

        let rookOffStr: string;
        let rookOnStr: string;

        let knightOffStr: string;
        let knightOnStr: string;

        let bishopOffStr: string;
        let bishopOnStr: string;

        let queenOffStr: string;
        let queenOnStr: string;

        if (GameVars.colorPlayer === GameConstants.WHITE) {

            rookOffStr = "white_rook.png";
            rookOnStr = "white_rook_on.png";

            knightOffStr = "white_knight_left.png";
            knightOnStr = "white_knight_left_on.png";

            bishopOffStr = "white_bishop.png";
            bishopOnStr = "white_bishop_on.png";

            queenOffStr = "white_queen.png";
            queenOnStr = "white_queen_on.png";

        } else {

            rookOffStr = "black_rook.png";
            rookOnStr = "black_rook_on.png";

            knightOffStr = "black_knight_left.png";
            knightOnStr = "black_knight_left_on.png";

            bishopOffStr = "black_bishop.png";
            bishopOnStr = "black_bishop_on.png";

            queenOffStr = "black_queen.png";
            queenOnStr = "black_queen_on.png";
        }

        let button_px = 65;
        let button_py = 60;

        let rookButton = new Phaser.Button( this.game, -button_px, -button_py, "texture_atlas_1", this.onClickPiece, this);
        rookButton.setFrames(rookOnStr, rookOffStr, rookOnStr);
        rookButton.anchor.set(.5);
        rookButton.name = GameConstants.BLACK_ROOK;
        menuContainer.add(rookButton);

        let knightButton = new Phaser.Button( this.game, button_px, -button_py, "texture_atlas_1", this.onClickPiece, this);
        knightButton.setFrames(knightOnStr, knightOffStr, knightOnStr);
        knightButton.anchor.set(.5);
        knightButton.name = GameConstants.BLACK_KNIGHT;
        menuContainer.add(knightButton);

        let bishopButton = new Phaser.Button( this.game, -button_px, button_py, "texture_atlas_1", this.onClickPiece, this);
        bishopButton.setFrames(bishopOnStr, bishopOffStr, bishopOnStr);
        bishopButton.anchor.set(.5);
        bishopButton.name = GameConstants.BLACK_BISHOP;
        menuContainer.add(bishopButton);

        let queenButton = new Phaser.Button( this.game, button_px, button_py, "texture_atlas_1", this.onClickPiece, this);
        queenButton.setFrames(queenOnStr, queenOffStr, queenOnStr);
        queenButton.anchor.set(.5);
        queenButton.name = GameConstants.BLACK_QUEEN;
        menuContainer.add(queenButton);

        this.alpha = 0;

        this.game.add.tween(this)
            .to({alpha: 1}, 400, Phaser.Easing.Cubic.Out, true, 750);
    }

    private onClickPiece(b: Phaser.Button): void {

        b.clearFrames();

        if (GameVars.challenge) {
            ChallengeManager.promotionPieceSelectedByPlayer(b.name);
        } else if (GameVars.againstAI) {
                BoardManagerAI.promotionPieceSelectedByPlayer(b.name);
        }
    }

    private onDownDarkLayer(): void {
        // nada
    }
}
